import { DynamicPropertyDtoToEntity } from "src/app/features/DynamicProperty/services/mappers/DynamicPropertyDtoToEntity";
import type { DynamicPropertyDto } from "src/app/features/DynamicProperty/types/DynamicPropertyDto";
import type { DynamicPropertyEntity } from "src/app/features/DynamicProperty/types/DynamicPropertyEntity";
import type { ResourcePageDto } from "../../../../../core/types/be/ResourcePageDto";
import type { ResourcePageEntity } from "../../../../../core/types/fe/entities/ResourcePageEntity";

export const DynamicPropertyTableDtoMapper = (
    input: Readonly<ResourcePageDto<DynamicPropertyDto>>,
): ResourcePageEntity<DynamicPropertyEntity> => {
    return {
        list: input.list ? input.list.map(DynamicPropertyDtoToEntity) : [],
        currentPage: input.currentPage,
        totalPages: input.totalPages,
        totalNumberOfResults: input.totalNumberOfResults,
    };
};
